export class TestTypeDTO{
    id!: number;
    name?: string;
    standard:any[]=[];
    glassBehaviour:any[]=[];
    sortOrder?: number;
    isActive?: boolean;
}